import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'src/app/store/types';

export const selectCheckedInvoiceRows = createSelector(
  (state: RootState) => state.invoice.selectedInvoiceRows,
  (invoiceRows) => {
    const ids = Object.keys(invoiceRows);
    return ids.filter((id) => !!invoiceRows[id]);
  }
);
